
import { CTNIcon } from '@ctn/ui/components/ctn-icon';
import { useState, type ReactElement } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import HelpModal from '@/components/HelpModal';
import { useGlobalContext } from '@/context/global.context';
import { usePageContext } from '@/context/page.context';
import useRouteTramite from '@/hooks/useRouteTramite';

import { ROUTES_RESOURCES } from '@/constants/routes.constants';

const TramiteSuccess = (): ReactElement => {
	const {
		maestrosTramite: {  configuracionTramite },
	} = useGlobalContext();
	const navigate = useNavigate();
	const { setBreadcrumb } = usePageContext();
	const ROUTES_TRAMITE = useRouteTramite();
	const location = useLocation();
	const numeroTramite = location.state?.numeroTramite ?? '';
	const id = location.state?.id ?? '';
	const [isOpenHelpModal, setIsOpenHelpModal] = useState(false);

	const listaArchivos = [
		{
			nombre: 'Guía de Autorización por Videoconferencia.pdf',
			url: `${ROUTES_RESOURCES.DESCARGAS}/Manual firmar por videoconferencia.pdf`,
		},
		{
			nombre: 'Guía de Acceso a videoconferencia desde PC.pdf',
			url: `${ROUTES_RESOURCES.DESCARGAS}/Manual firmar por PC.pdf`,
		},
		{
			nombre: 'Guía de Acceso a videoconferencia desde móvil.pdf',
			url: `${ROUTES_RESOURCES.DESCARGAS}/Manual firmar por móvil.pdf`,
		}
	];

	return (
		<div className='c-pnp-success'>
			<div className='c-pnp-success__title-container'>
				<CTNIcon icon='okCircleOutline' color='green-50' size="size-80"/>
				<h1>Solicitud enviada correctamente.</h1>
			</div>
			<div className='[ c-pnp-success__body-container ] [ u-mt-24 ]'>
				{configuracionTramite?.permitePreseleccionNotario ? (
					<p>
						Tu solicitud con número {numeroTramite}, se ha enviado a la notaría que has elegido. 
						El notario gestionará el expediente y te comunicará la resolución a través de este portal o se pondrá en contacto contigo si necesita información o documentación adicional. 
					</p>
				) : (
					<>
						<p>
							La solicitud se encuentra pendiente de asignación a notario, y deberán ser 
							los intervinientes los que seleccionen a uno de su elección.
						</p>
						<br />
						<p>
							Para ello, se deberán poner en contacto con el notario elegido o personarse 
							en la notaría para proceder a la asignación y gestión de la solicitud con número {numeroTramite}.
						</p>
					</>
				)}
			</div>
			<div className='[ c-pnp-success__body-container ] [ u-mt-32 ]'>
				<button
					type="button"
					className='c-pnp-success__link' 
					onClick={() => {
						setBreadcrumb(undefined);
						navigate(`${ROUTES_TRAMITE.SOLICITUDES}/${id}`);
					}}
				>
					{`Seguimiento de tu solicitud con número ${numeroTramite}`}
				</button>
				<button
					type="button"
					className='c-pnp-success__link' 
					onClick={() => {
						setBreadcrumb(undefined);
						navigate(`${ROUTES_TRAMITE.SOLICITUDES}`);
					}}
				>Listado de solicitudes
				</button>
				<button
					type="button"
					className='c-pnp-success__link' 
					onClick={() => setIsOpenHelpModal(true)}
				>Cómo firmar por videoconferencia
				</button>
			</div>
			<HelpModal archivos={listaArchivos} isShow={isOpenHelpModal} onClose={() => setIsOpenHelpModal(false)} />
		</div>
	);
};

export default TramiteSuccess;
